import { Checkbox as AntdCheckbox } from "antd"
import "./Checkbox.module.less"

export const Checkbox = AntdCheckbox
